/* MALU — product page enhancement.
   The variant picker is rendered by Liquid. This asks the server to re-render the
   section for the newly selected option values and swaps the markup in, so the
   browser never carries a variant catalogue. */

(function () {
  'use strict';

  function swapShot(root, src) {
    var shot = root.querySelector('.product__shot img');
    if (!shot) return;
    // The main shot ships with a srcset/sizes pair for responsive loading. While
    // those attributes are present the browser picks its own candidate and a new
    // src is ignored, so they have to go before the swap takes effect.
    shot.removeAttribute('srcset');
    shot.removeAttribute('sizes');
    shot.src = src;
  }

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-malu-thumb]');
    if (!thumb) return;
    var root = thumb.closest('[data-malu-product]');
    if (!root) return;

    swapShot(root, thumb.getAttribute('data-malu-thumb'));

    var all = root.querySelectorAll('[data-malu-thumb]');
    for (var i = 0; i < all.length; i++) all[i].classList.remove('product__thumb--on');
    thumb.classList.add('product__thumb--on');
  });

  document.addEventListener('change', async function (event) {
    var selectors = event.target.closest('.option-value-selectors');
    if (!selectors) return;

    var root = selectors.closest('[data-malu-product]');
    if (!root) return;

    var sectionId = selectors.dataset.sectionId;
    var optionValues = Array.from(selectors.querySelectorAll('input[type="radio"]:checked'))
      .map(function (input) {
        return input.dataset.optionValueId;
      })
      .join(',');

    var response = await fetch(
      window.location.pathname + '?section_id=' + sectionId + '&option_values=' + optionValues
    );
    var html = new DOMParser().parseFromString(await response.text(), 'text/html');
    var fresh = html.querySelector('[data-malu-product]');
    if (!fresh) return;

    var selectedId = event.target.id;
    root.innerHTML = fresh.innerHTML;

    var restored = document.getElementById(selectedId);
    if (restored) restored.focus();
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.product__form');
    if (!form) return;
    if (!window.MALUCart) return;

    event.preventDefault();

    var idField = form.querySelector('[name="id"]');
    var qtyField = form.querySelector('[name="quantity"]');
    var submit = form.querySelector('[type="submit"]');
    if (!idField) return;

    if (submit) submit.setAttribute('aria-disabled', 'true');

    window.MALUCart.add({
      id: idField.value,
      quantity: qtyField ? Number(qtyField.value) : 1
    }).finally(function () {
      if (submit) submit.removeAttribute('aria-disabled');
    });
  });
})();
